import UserDetailsSubHeader from './UserDetailsSubHeader'

export default UserDetailsSubHeader
